import { PageId } from 'constants/pages'

export const enum PageIdWoofzOffer180 {
  SUBSCRIPTIONS_OFFER1_80 = PageId.SUBSCRIPTIONS_OFFER1_80,
  CHAT_UPSELL_OFFER1_80 = PageId.CHAT_UPSELL_OFFER1_80,
  UPSELL_OFFER1_80 = PageId.UPSELL_OFFER1_80,
  DOWNLOAD_OFFER1_80 = PageId.DOWNLOAD_OFFER1_80,
  ACCOUNT_NOVE8 = PageId.ACCOUNT_NOVE8,
}
